const delay = ({ ms }: { ms: number }) => new Promise<void>((resolve) => setTimeout(resolve, ms));
export default delay;
